/**
 * @module
 * @exports ready
 * @description The core dispatcher for the dom ready event in javascript.
 *
 */

import { consoleInfo, ready } from '@gravityforms/utils';
import settings from '../settings';
import map from '../map';

/**
 * @function init
 * @description The core dispatcher for init across the codebase.
 *
 */

const init = () => {
	// Initialize settings

	settings();
	map();

	consoleInfo( 'Gravity Forms Geolocation Admin: Initialized all javascript that targeted document ready.' );
};

/**
 * @function domReady
 * @description Export our dom ready enabled init.
 *
 */

const domReady = () => {
	ready( init );
};

export default domReady;
